__webpack_require__.p = "https://cdn.n-tv.de/sport/0.89.4/_next/";